module.exports = __webpack_public_path__ + "2c0c224a3d32e5cddd617b99636346b7.pdf";